// ACTION CREATOR SET_OPEN_COOKIE_POPUP
export const SET_OPEN_COOKIE_POPUP = 'SET_OPEN_COOKIE_POPUP';

// ACTION CREATOR setOpenCookiePopup
export const setOpenCookiePopup = (value) => ({
  type: SET_OPEN_COOKIE_POPUP,
  value,
});
